import FeaturesReducer from './Features.reducer';
import FetchingReducer from './Fetching.reducer';
import InsightsGlobalFilterReducer from './InsightsGlobalFilters.reducer';
import IntegrationReducer from './Integration.reducer';
import LoginReducer from './Login.reducer';
import ManualCaseReducer from './ManualCase';
import OpenReportingReducer from './OpenReporting';
import OrganisationReducer from './Organisation.reducer';
import UserReducer from './User.reducer';

export { UserReducer as globalUsers };
export { OrganisationReducer as organisation };
export { FetchingReducer as fetching };
export { FeaturesReducer as features };
export { LoginReducer as login };
export { OpenReportingReducer as openReporting };
export { IntegrationReducer as integrationStatus };
export { ManualCaseReducer as manualCaseCreation };
export { InsightsGlobalFilterReducer as insightsGlobalFilters };

export const legacyReducers = {
  globalUsers: UserReducer,
  organisation: OrganisationReducer,
  fetching: FetchingReducer,
  features: FeaturesReducer,
  login: LoginReducer,
  openReporting: OpenReportingReducer,
  integrationStatus: IntegrationReducer,
  manualCaseCreation: ManualCaseReducer,
  insightsGlobalFilters: InsightsGlobalFilterReducer,
};

export default legacyReducers;
